/*
 * Quick view popup for product cards whose product has options.
 *
 * A card opts in by putting data-quick-view="<product handle>" on its add to cart <form>
 * (sections/main-collection-products.liquid, sections/product-recommendations.liquid).
 * Clicking the card's CTA opens this popup instead of adding the default variant. After a variant is
 * chosen, the card's own submit button is clicked with the form's variant id swapped, so the store's
 * existing add to cart behaviour (AJAX add, cart drawer, tracking) runs exactly as it does for any card.
 */
(function() {
  if (window.cardQuickViewLoaded) return;
  window.cardQuickViewLoaded = true;

  /* Set in layout/theme.liquid from the theme settings */
  const config = Object.assign({ quickView: true, buyNow: false }, window.cardQuickViewConfig);
  const CARD_FORM = 'form[data-quick-view]';
  const productCache = {};
  let modal = null;
  let els = null;
  let current = null;

  /* Button text of the first card Buy Now button, so the popup matches the store's Buy Now wording */
  function buyNowLabel() {
    const card = document.querySelector('[data-card-buy-now]');
    const text = card && Array.from(card.childNodes)
      .filter(function(node) { return node.nodeType === 3; })
      .map(function(node) { return node.textContent; })
      .join('')
      .trim();
    return text || 'Buy Now';
  }

  /* The card's add to cart form: the nearest ancestor of the button that contains one */
  function findCardForm(el) {
    let node = el;
    while (node && node !== document.body) {
      const form = node.querySelector && node.querySelector(CARD_FORM);
      if (form) return form;
      node = node.parentElement;
    }
    return null;
  }

  /*
   * GoKwik's Buy Now adds the item to the cart, and GoKwik's side cart script opens the mini cart on every
   * /cart/add. Keep the mini cart closed while a Buy Now is starting so only the GoKwik checkout popup shows,
   * then put GoKwik's functions back once the popup is on screen (or after a safety timeout).
   */
  function suppressMiniCart() {
    const originalOpen = window.openGokwikSideCart;
    const wasActive = window.kwikCartActive;
    if (typeof originalOpen !== 'function' && !wasActive) return;

    const noop = function() {};
    window.openGokwikSideCart = noop;
    window.kwikCartActive = false;

    const started = Date.now();
    let timer = null;

    function restore() {
      clearInterval(timer);
      if (window.openGokwikSideCart === noop) window.openGokwikSideCart = originalOpen;
      window.kwikCartActive = wasActive;
    }

    timer = setInterval(function() {
      const frame = document.getElementById('gokwik-iframe');
      if (frame && frame.offsetParent !== null) {
        clearInterval(timer);
        setTimeout(restore, 1500);
      } else if (Date.now() - started > 12000) {
        restore();
      }
    }, 150);
  }

  /* GoKwik's Buy Now accepts the items to buy: onBuyNowClick(button, formSelector, [{ id, quantity }]) */
  function buyNow(btn, variantId) {
    if (window.CtaLoader) window.CtaLoader.startBuy(btn);
    suppressMiniCart();
    if (typeof window.onBuyNowClick === 'function') {
      window.onBuyNowClick(btn, false, [{ id: variantId, quantity: 1 }]);
    } else {
      window.location.href = '/cart/' + variantId + ':1';
    }
  }

  function formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat((window.Shopify && Shopify.locale) || undefined, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function imageUrl(src, width) {
    if (!src) return '';
    const clean = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function(response) {
        if (!response.ok) throw new Error('Product request failed: ' + response.status);
        return response.json();
      }).catch(function(error) {
        delete productCache[handle];
        throw error;
      });
    }
    return productCache[handle];
  }

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'cqv';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="cqv__backdrop" data-cqv-close></div>' +
      '<div class="cqv__dialog" role="dialog" aria-modal="true" aria-labelledby="cqv-title" tabindex="-1">' +
        '<button type="button" class="cqv__close" data-cqv-close aria-label="Close">&times;</button>' +
        '<div class="cqv__loading" data-cqv-loading>Loading&hellip;</div>' +
        '<div data-cqv-body hidden>' +
          '<div class="cqv__head">' +
            '<img class="cqv__img" data-cqv-img alt="" width="96" height="96">' +
            '<div class="cqv__info">' +
              '<a class="cqv__title" id="cqv-title" data-cqv-title href="#"></a>' +
              '<div class="cqv__price"><span class="cqv__now" data-cqv-now></span><span class="cqv__compare" data-cqv-compare hidden></span></div>' +
            '</div>' +
          '</div>' +
          '<div class="cqv__options" data-cqv-options></div>' +
          '<div class="cqv__actions">' +
            '<div class="cqv__buttons">' +
              '<button type="button" class="cqv__add" data-cqv-add>Add to Cart</button>' +
              (config.buyNow
                ? '<button type="button" class="cqv__buy" data-cqv-buy>' + buyNowLabel() + '</button>'
                : '') +
            '</div>' +
            '<a class="cqv__details" data-cqv-details href="#">View full details</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    els = {
      dialog: modal.querySelector('.cqv__dialog'),
      loading: modal.querySelector('[data-cqv-loading]'),
      body: modal.querySelector('[data-cqv-body]'),
      img: modal.querySelector('[data-cqv-img]'),
      title: modal.querySelector('[data-cqv-title]'),
      now: modal.querySelector('[data-cqv-now]'),
      compare: modal.querySelector('[data-cqv-compare]'),
      options: modal.querySelector('[data-cqv-options]'),
      add: modal.querySelector('[data-cqv-add]'),
      buy: modal.querySelector('[data-cqv-buy]'),
      details: modal.querySelector('[data-cqv-details]')
    };

    modal.querySelectorAll('[data-cqv-close]').forEach(function(el) {
      el.addEventListener('click', close);
    });
    els.add.addEventListener('click', addToCart);
    if (els.buy) {
      els.buy.addEventListener('click', function() {
        if (!current || !current.variant || !current.variant.available) return;
        const variantId = current.variant.id;
        /* The popup closes, so the spinner goes on the card button that opened it */
        const buyBtn = (current.opener && document.contains(current.opener)) ? current.opener : els.buy;
        close();
        buyNow(buyBtn, variantId);
      });
    }
    document.addEventListener('keydown', onKeydown);
  }

  function onKeydown(event) {
    if (!modal || modal.hidden) return;

    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = Array.from(els.dialog.querySelectorAll('button:not(:disabled), a[href]'))
      .filter(function(el) { return el.offsetParent !== null; });
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && (document.activeElement === first || document.activeElement === els.dialog)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function findVariant(product, options) {
    return product.variants.find(function(variant) {
      return variant.options.every(function(value, index) { return options[index] === value; });
    });
  }

  function render() {
    const product = current.product;
    const variant = current.variant;

    els.title.textContent = product.title;
    els.title.href = product.url;
    els.details.href = product.url;

    const image = (variant.featured_image && variant.featured_image.src) || product.featured_image;
    if (image) {
      const src = imageUrl(image, 320);
      if (els.img.getAttribute('src') !== src) els.img.src = src;
      els.img.alt = product.title;
    }

    els.now.textContent = formatMoney(variant.price);
    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    els.compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
    els.compare.hidden = !onSale;

    els.options.innerHTML = '';
    product.options.forEach(function(option, index) {
      const group = document.createElement('div');
      group.className = 'cqv__group';

      const label = document.createElement('div');
      label.className = 'cqv__label';
      label.appendChild(document.createTextNode(option.name + ': '));
      const selected = document.createElement('span');
      selected.textContent = current.options[index];
      label.appendChild(selected);
      group.appendChild(label);

      const values = document.createElement('div');
      values.className = 'cqv__values';

      option.values.forEach(function(value) {
        const test = current.options.slice();
        test[index] = value;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cqv__btn' + (current.options[index] === value ? ' is-active' : '');
        btn.textContent = value;
        btn.disabled = !findVariant(product, test);
        btn.addEventListener('click', function() { selectOption(index, value); });
        values.appendChild(btn);
      });

      group.appendChild(values);
      els.options.appendChild(group);
    });

    els.add.disabled = !variant.available;
    els.add.textContent = variant.available ? 'Add to Cart' : 'Sold out';
    if (els.buy) els.buy.disabled = !variant.available;
  }

  function selectOption(index, value) {
    const product = current.product;
    const next = current.options.slice();
    next[index] = value;

    let variant = findVariant(product, next);
    if (!variant) {
      /* That combination doesn't exist: fall back to the first variant that has the chosen value */
      variant = product.variants.find(function(v) { return v.options[index] === value; });
    }
    if (!variant) return;

    current.variant = variant;
    current.options = variant.options.slice();
    render();
  }

  function open(handle, form, opener) {
    if (!modal) buildModal();

    opener = opener || document.activeElement;
    current = { form: form || findCardForm(opener), opener: opener, handle: handle };

    /* Show only the action that opened the popup: the card's Buy Now opens it with Buy Now, its Add to Cart with Add to Cart */
    const buyMode = !!els.buy && !!opener && opener.matches && opener.matches('[data-card-buy-now]');
    els.add.hidden = buyMode;
    if (els.buy) els.buy.hidden = !buyMode;

    els.loading.hidden = false;
    els.body.hidden = true;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    els.dialog.focus();

    fetchProduct(handle).then(function(product) {
      if (!current || current.handle !== handle || modal.hidden) return;

      const variant = product.variants.find(function(v) { return v.available; }) || product.variants[0];
      current.product = product;
      current.variant = variant;
      current.options = variant.options.slice();

      render();
      els.loading.hidden = true;
      els.body.hidden = false;
    }).catch(function() {
      /* Couldn't load the options: send the shopper to the product page instead */
      close();
      window.location.href = '/products/' + handle;
    });
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    const opener = current && current.opener;
    if (opener && document.contains(opener)) opener.focus();
  }

  function addToCart() {
    if (!current || !current.variant || !current.variant.available) return;

    const form = current.form;
    const submitBtn = form && form.querySelector('[type="submit"]');
    if (!submitBtn) return;

    /* Cards carry the variant either in a hidden "id" input or, for the home page block, in data-variant-id */
    const idInput = form.querySelector('[name="id"]');
    const usesAttribute = !idInput && form.hasAttribute('data-variant-id');
    if (!idInput && !usesAttribute) return;

    const originalId = idInput ? idInput.value : form.getAttribute('data-variant-id');
    const setId = function(id) {
      if (idInput) idInput.value = id;
      else form.setAttribute('data-variant-id', id);
    };

    setId(current.variant.id);
    form.dataset.cqvBypass = 'true';
    close();

    /* Click the card's own button so the store's add to cart handling runs as usual (the loader starts on it) */
    submitBtn.click();

    setTimeout(function() {
      delete form.dataset.cqvBypass;
      setId(originalId);
    }, 1500);
  }

  /* Card CTA click / form submit: open the popup instead of adding the default variant */
  function interceptCard(event) {
    const target = event.target;
    if (!target || !target.closest) return;

    let form = null;
    let opener = null;
    if (event.type === 'click') {
      opener = target.closest('button[type="submit"], input[type="submit"]');
      form = opener && (opener.form || opener.closest('form'));
    } else {
      form = target.matches && target.matches('form') ? target : target.closest('form');
      opener = form && form.querySelector('[type="submit"]');
    }

    if (!form || !form.matches(CARD_FORM) || !form.dataset.quickView || form.dataset.cqvBypass) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    open(form.dataset.quickView, form, opener);
  }

  /* Card Buy Now: products with options choose a variant in the popup first, others buy straight away */
  function interceptBuyNow(event) {
    const btn = event.target && event.target.closest && event.target.closest('[data-card-buy-now]');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const handle = btn.dataset.quickView;
    if (handle && config.quickView) {
      open(handle, findCardForm(btn), btn);
      return;
    }
    buyNow(btn, Number(btn.dataset.variantId));
  }

  if (config.quickView) {
    window.addEventListener('click', interceptCard, true);
    window.addEventListener('submit', interceptCard, true);
  }
  if (config.buyNow) {
    window.addEventListener('click', interceptBuyNow, true);
  }

  /* The PDP's own GoKwik Buy Now button (also clicked by the sticky bar) gets the same popup-only behaviour */
  window.addEventListener('click', function(event) {
    if (event.target && event.target.closest && event.target.closest('#gokwik-buy-now')) suppressMiniCart();
  }, true);
})();
